import { Label, Select } from "flowbite-react";

export function SelectInput({
  id = "select-input",
  label = "",
  children,
  value,
  onChange,
  required = false,
  className = "",
  ...rest
}) {
  return (
    <div className={` ${className}`}>
      {label && <Label htmlFor={id}>{label}</Label>}

      <Select
        id={id}
        value={value}
        onChange={onChange}
        required={required}
        className="text-gray-700 focus:ring-2 focus:ring-blue-500"
        {...rest}
      >
        {children}
      </Select>
    </div>
  );
}
